import DataStoreMock from './base/data-store';

import { CreatePermissionItem, PermissionItem, PermissionSummary } from 'src/stores/permissions-store';
import FormStoreMock from './base/form-store';
import { Query } from '@testing-library/react';
import { PermissionSummaryMockData } from '../data-sources/permission-summary';

export class PermissionSummaryStoreMock extends DataStoreMock<PermissionSummary> {
  public async loadPermissions(_query: Partial<Query>) {
    this._state.set({
      isBusy: false,
      items: PermissionSummaryMockData,
      count: PermissionSummaryMockData.length,
    });
    return PermissionSummaryMockData;
  }
}

export class PermissionItemStoreMock extends FormStoreMock<PermissionItem, CreatePermissionItem> {
  groupRolesBasePath = 'roles';
  public async addPermissionRoles(id: string, roleIds: string[]) {
    return { isSuccess: true, error: '', messages: [] };
  }
  public async deletePermissionRoles(id: string, roleIds: string[]) {
    return { isSuccess: true, error: '', messages: [] };
  }
}
